/* Only measure layout; Shopify renders offer/cart content on the server. */
(() => {
  'use strict';
  const ribbon = document.querySelector('[data-bm-launch-sale]');
  if (!ribbon || ribbon.dataset.bmMeasured) return;
  ribbon.dataset.bmMeasured = 'true';
  const root = document.documentElement;
  let frame = 0;
  let lastHeight = -1;
  const measure = () => {
    frame = 0;
    const height = Math.ceil(ribbon.getBoundingClientRect().height);
    if (height !== lastHeight) {
      root.style.setProperty('--bm-launch-sale-height', `${height}px`);
      lastHeight = height;
    }
  };
  const queue = () => {
    if (!frame) frame = requestAnimationFrame(measure);
  };
  measure();
  if ('ResizeObserver' in window) new ResizeObserver(queue).observe(ribbon);
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('pageshow', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
})();
